import { __awaiter, __generator } from "tslib";
export var fetchIcon = function (badgeIcon, httpClient) { return __awaiter(void 0, void 0, void 0, function () {
    var fetchIconResponse, hasLoadFailed, iconContent, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, httpClient.get(badgeIcon)];
            case 1:
                fetchIconResponse = _b.sent();
                hasLoadFailed = fetchIconResponse.status !== 200;
                iconContent = hasLoadFailed ? '' : fetchIconResponse.data;
                return [2 /*return*/, { hasLoadFailed: hasLoadFailed, iconContent: iconContent }];
            case 2:
                _a = _b.sent();
                return [2 /*return*/, { hasLoadFailed: true, iconContent: '' }];
            case 3: return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=icon.js.map